module.exports = __webpack_public_path__ + "static/media/Discovery-Insight.fa108dd5.svg";